import React, { useState } from "react";
import { useRouteMatch } from "react-router-dom";
import { GET_STANDS_CURSOR } from 'graphql/query/stand-gql';
import GraphicStand from 'components/graphic-stand';
import { useActiveMenuItem, useBreadCrumbs } from "components/use-hooks";
import { PageWrapDefault, Tables, TotalItems } from "components/layout";
import { Localize } from "components/service";
import { gqlBuilderWhere } from "utils";

const tableHelper = GraphicStand.Helpers.TableWarehouse;

const GraphicWarehousePage = () => {
    useActiveMenuItem([ "graphic-warehouse" ], [ "graphic-warehouse" ]);

    const breadcrumbs = [
        {
            label: Localize({ children: "MENUS.Label_GraphicWarehouse" }).props.children,
            path: `/graphic-warehouse`
        }
    ]

    useBreadCrumbs(breadcrumbs);

    let match = useRouteMatch(`/graphic-warehouse/page/:pageNum`);

    const filterTable = 'table-graphic-warehouse';

    const graphicWarehouseFilters = JSON.parse(localStorage.getItem(`graphicWarehouseFilters-${ filterTable }`));
    const graphicWarehouseSorting = JSON.parse(localStorage.getItem(`graphicWarehouseSorting-${ filterTable }`));
    const graphicWarehouseSearch = JSON.parse(localStorage.getItem(`graphicWarehouseSearch-${ filterTable }`));

    const [ searchText, setSearchText ] = useState(graphicWarehouseSearch);
    const [ filters, setFilters ] = useState(gqlBuilderWhere(graphicWarehouseFilters));
    const [ resetSorting, setResetSorting ] = useState(false);

    const { where: objFilter, whereEvents } = GraphicStand.Helpers.Filter.separateFilters({
        AND: [
            { column: 'SHELF_NUMBER', operator: 'IS_NOT_NULL' },
            { column: 'SHELF_NUMBER', operator: 'NEQ', value: '' },
            ...(!filters ? [] : Array.isArray(filters) ? filters : [ filters ])
        ]
    });

    const objOrderBy = [ { column: 'ID', order: 'DESC' } ];

    return (
        <PageWrapDefault
            className="page-graphic-warehouse"
            dataExist={ true }
            title={ <Localize>MENUS.Label_GraphicWarehouse</Localize> }
        >
            <Tables.Cursor
                extraClass="table-graphic-warehouse"
                tableLayout=""
                model="standsCursor"
                query={ GET_STANDS_CURSOR }
                varSet={ {
                    exclude_graphics_sent: true,
                    perPage: 100,
                    whereCrafts: { column: 'TYPE', value: "collect_graphics" },
                    ...(whereEvents ? { whereEvents } : {})
                } }
                routeUrl={ `/graphic-warehouse` }
                currentPage={ match ? parseInt(match.params.pageNum) : 1 }
                searchText={ searchText }
                objFilter={ objFilter }
                objOrderBy={ graphicWarehouseSorting || objOrderBy }
                sortingName={ `graphicWarehouseSorting-${ filterTable }` }
                tableHelper={ tableHelper }
                resetSorting={ resetSorting }
                filterTable={ filterTable }
            >
                { ({ pageInfo, model }) => (
                    <div className="table-action-bar">
                        <div className="col">
                            <GraphicStand.Filters.Table
                                setSearchText={ setSearchText }
                                setFilters={ setFilters }
                                filters={ filters }
                                graphicStandsFilters={ graphicWarehouseFilters }
                                setResetSorting={ setResetSorting }
                                filterTable={ filterTable }
                            />
                            <TotalItems
                                pageInfo={ pageInfo }
                            />
                        </div>
                        <div className="col"></div>
                    </div>) }
            </Tables.Cursor>
        </PageWrapDefault>
    );
};

export default GraphicWarehousePage;
